import React, { useEffect, useState } from "react";
import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { FaStar, FaStarHalfAlt, FaRegStar, FaExclamationTriangle, FaInfoCircle } from "react-icons/fa";
import 'yet-another-react-lightbox/styles.css';
import Lightbox from 'yet-another-react-lightbox';
import Swal from 'sweetalert2';
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdClose, MdDelete, MdModeEdit, MdVerified } from "react-icons/md";
import ApiClient from "../../api-client";

import pdf from "../../assets/img/pdf.svg"


import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Label,
  Spinner,
  CardImg,
  Table,
  Form,
  FormGroup,
  Input,
  InputGroup,
  
  InputGroupText,
} from "reactstrap";
import Map from "../Map";
import { RiAddCircleLine, RiDeleteBinLine } from "react-icons/ri";

function UpdateProviderServiceDetails() {
    const location = useLocation();
    const { providerId, serviceId} = location.state || {};
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [videoLinks, setVideoLinks] = useState([]);

    const [serviceTitle, setServiceTitle] = useState("");
    const [commonLocationPrice, setCommonLocationPrice] = useState("");
    const [homeVisitPrice, setHomeVisitPrice] = useState("");
    const [onlinePrice, setOnlinePrice] = useState("");
    const [extraChargesPrice, setExtraChargesPrice] = useState("");
    const [maxPeopleAllowed, setMaxPeopleAllowed] = useState("");
    const [numberOfPeopleIncluded, setNumberOfPeopleIncluded] = useState("");
    const [specialities, setSpecialities] = useState("");
    const [qualification, setQualification] = useState("");
    const [experience, setExperience] = useState("");
    const [description, setDescription] = useState("");
    const [portfolioImages, setPortfolioImages] = useState([]);
    const [portfolioPrevImages, setPortfolioPrevImages] = useState([]);
    const [selectedPortfolioImages, setSelectePortfolioImages] = useState([]);
    const [categories, setAllCategory] = useState([]);
    const [categoryId, setCategoryId] = useState("");

    const [allSubCategories, setAllSubCategory] = useState([]);
    const [subcategoryId, setSubcategoryId] = useState("");

    const [removedImages, setRemovedImages] = useState([]);

    const [licenseImages, setLicenseImages] = useState([]);
    const [licensePrevImage, setLicensePrevImage] = useState([]);
    const [selectedLicenseImages, setSelecteLicenseImages] = useState([]);

    const [onlineChecked, setOnlineChecked] = useState(false);
    const [commonLocationChecked, setCommonLocationChecked] = useState(false);
    const [homeVisitChecked, setHomeVisitChecked] = useState(false);


    // Validation state
    const [errors, setErrors] = useState({});

    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");

    const fetchDetails = async () => {
        try {
            setLoader(true);
            const getDetails = await ApiClient.get(
                `api/service/get-service-by-id/${id}`,
                "",
                true,
                dispatch
            );

            if (getDetails?.body) {
                setUserDetails(getDetails?.body);
                setServiceTitle(getDetails?.body?.serviceTitle || "");
                setCommonLocationPrice(getDetails?.body?.pricing?.commonLocation?.price || "");
                setHomeVisitPrice(getDetails?.body?.pricing?.homeVisit?.price || ""); 
                setOnlinePrice(getDetails?.body?.pricing?.online?.price || "");
                setOnlineChecked(getDetails?.body?.pricing?.online?.isChecked || false)
                setCommonLocationChecked(getDetails?.body?.pricing?.commonLocation?.isChecked || false)
                setHomeVisitChecked(getDetails?.body?.pricing?.homeVisit?.isChecked || false)
                setExtraChargesPrice(getDetails?.body?.extraCharges || "");
                setMaxPeopleAllowed(getDetails?.body?.maxPeopleAllowed || "");
                setNumberOfPeopleIncluded(getDetails?.body?.numberOfPeopleIncluded || "");
                setSpecialities(getDetails?.body?.specialities || "");
                setQualification(getDetails?.body?.qualification || "");
                setExperience(getDetails?.body?.experience || "");
                setDescription(getDetails?.body?.description || "");
                setPortfolioImages(getDetails?.body?.portfolioImage || [])
                setPortfolioPrevImages(getDetails?.body?.portfolioImageThumbnail || []);
                setLicenseImages(getDetails?.body?.licenseImage || [])
                setLicensePrevImage(getDetails?.body?.licenseImageThumbnail || []);
                setCategoryId(getDetails?.body?.categoryId?._id || "")
                setSubcategoryId(getDetails?.body?.subcategoryId?._id || "")
                setVideoLinks(getDetails?.body?.videoLink);

            }
            setLoader(false);
        } catch (error) {
            toast.error(error.message, { autoClose: 3000 });
            setLoader(false);
        }
    };

    const getAllCategory = async () => {
        console.log("getAllCategory");
        try {
          const getAllCategory = await ApiClient.get(
            "api/category/get-category",
            "",
            true,
            dispatch
          );
          const categories = getAllCategory.body.map((category) => {
            return {
              categoryId: category._id,
              categoryName: category.categoryName,
            };
          });
          setAllCategory(categories);
        //   if (subcategoryId) {
        //     console.log("call setSubcategory");
        //     getSubcategoryById();
        //   }
        } catch (error) {
          setAllCategory([]);
        }
      };

    const getAllSubCategory = async () => {
        console.log("getAllsubCategory");
        try {
          const getAllSubCategory = await ApiClient.get(
            "api/category/get-all-subcategory",
            "",
            true,
            dispatch
          );
          const subcategories = getAllSubCategory.body.map((subcategory) => {
            return {
              subcategoryId: subcategory._id,
              subcategoryName: subcategory.subCategoryName,
            };
          });
          setAllSubCategory(subcategories);
        //   if (subcategoryId) {
        //     console.log("call setSubcategory");
        //     getSubcategoryById();
        //   }
        } catch (error) {
            setAllSubCategory([]);
        }
      };

    useEffect(() => {
        fetchDetails();
        getAllCategory()
        getAllSubCategory()
    }, []);

  
    const handleImageSelection = (e, context) => {
        const files = Array.from(e.target.files);
        if (context === 'portfolio') {
            setSelectePortfolioImages(prevImages => [...prevImages, ...files]);
        } else if (context === 'license') {
            setSelecteLicenseImages(prevImages => [...prevImages, ...files]);
        }
    };

     const validate= () => {
        const errors = {};

        if (!serviceTitle.trim()) {
            errors.serviceTitle = 'Service Title is required.';
        }

        if (!categoryId) {
            errors.categoryId = 'Service Category is required.';
        }

        if (!subcategoryId) {
            errors.subcategoryId = 'Service Subcategory is required.';
        }

        if (!/^\d+(\.\d{1,2})?$/.test(commonLocationPrice)) {
            errors.commonLocationPrice = 'Common Location Price should be a number.';
        }

        if (!/^\d+(\.\d{1,2})?$/.test(homeVisitPrice)) {
            errors.homeVisitPrice = 'Home Visit Price should be a number.';
        }

        if (!/^\d+(\.\d{1,2})?$/.test(onlinePrice)) {
            errors.onlinePrice = 'Online Price should be a number.';
        }

        if (!/^\d+(\.\d{1,2})?$/.test(extraChargesPrice)) {
            errors.extraChargesPrice = 'Extra Charges Price should be a number.';
        }

        if (!/^\d+$/.test(maxPeopleAllowed)) {
            errors.maxPeopleAllowed = 'Max People Allowed should be a number.';
        }

        if (!/^\d+$/.test(numberOfPeopleIncluded)) {
            errors.numberOfPeopleIncluded = 'Number Of People Included should be a number.';
        }

        if (!specialities.trim()) {
            errors.specialities = 'Specialties is required.';
        }

        if (!qualification.trim()) {
            errors.qualification = 'Qualification is required.';
        }

        if (!experience.trim()) {
            errors.experience = 'Experience is required.';
        }

        if (!description.trim()) {
            errors.description = 'Service Description is required.';
        }

        if ((!selectedPortfolioImages || selectedPortfolioImages.length === 0) && (!portfolioPrevImages || portfolioPrevImages.length === 0)) {
            errors.portfolioImages = "Portfolio image is required";
          } else {
            // Check the size of each selected image
            for (let image of selectedPortfolioImages) {
              if (image.size / 1000000 > 5) { // size is in bytes, so converting to MB
                errors.portfolioImages = "Uploaded File size should not be greater than 5MB.";
                break;
              }
            }
          }

          if ((!selectedLicenseImages || selectedLicenseImages.length === 0) && (!licensePrevImage || licensePrevImage.length === 0)) {
            errors.licenseImages = "License document is required.";
          } else {
            // Check the size of each selected image
            for (let image of selectedPortfolioImages) {
              if (image.size / 1000000 > 5) { // size is in bytes, so converting to MB
                errors.licenseImages = "Uploaded File size should not be greater than 5MB.";
                break;
              }
            }
          }
     
        return errors;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
        }else{
                setErrors({});
                const formData = new FormData();
                formData.append("serviceTitle", serviceTitle);
                formData.append("commonLocationPrice", commonLocationPrice);
                formData.append("homeVisitPrice", homeVisitPrice);
                formData.append("onlinePrice", onlinePrice);
                formData.append("extraCharges", extraChargesPrice);
                formData.append("maxPeopleAllowed", maxPeopleAllowed);
                formData.append("numberOfPeopleIncluded", numberOfPeopleIncluded);
                formData.append("specialities", specialities);
                formData.append("qualification", qualification);
                formData.append("experience", experience);
                formData.append("description", description);
                selectedPortfolioImages.forEach(image => formData.append("portfolioImages", image));
                selectedLicenseImages.forEach(image => formData.append("licenseImages", image));
                formData.append("onlinePriceChecked", onlineChecked);
                formData.append("commonLocationPriceChecked", commonLocationChecked);
                formData.append("homeVisitPriceChecked", homeVisitChecked);
                formData.append("categoryId", categoryId);
                formData.append("subcategoryId", subcategoryId);
                if(videoLinks.length === 0){
                    formData.append("videoLink",[]);
                  }else {
                    for (const link of videoLinks) {
                      formData.append('videoLink', link);
                    }
                  }
                formData.append("providerId", providerId);//add provider id
                formData.append("serviceId", serviceId);//add serviceId id
                if (removedImages.length > 0) {
                    removedImages.forEach(image => formData.append("removedImages", image));
                  } else {
                    formData.append("removedImages",'');
                  }

            try {
                setLoader(true);  
                const updateDetails = await ApiClient._putFormData(
                    `api/service/update-service`,
                    formData,
                    true,
                    dispatch
                );
    
                if (updateDetails.status === true) {
                    toast.success(updateDetails.message, { autoClose: 3000 });
                    setServiceTitle('')
                    setCommonLocationPrice('')
                    setHomeVisitPrice('')
                    setOnlinePrice('')
                    setExtraChargesPrice('')
                    setMaxPeopleAllowed('')
                    setNumberOfPeopleIncluded('')
                    setSpecialities('')
                    setQualification('')
                    setExperience('')
                    setDescription('')
                    setPortfolioImages([])
                    setPortfolioPrevImages([])
                    setSelectePortfolioImages([])
                    setAllCategory([])
                    setCategoryId('')
                    setAllSubCategory([])
                    setSubcategoryId('')
                    setRemovedImages([])
                    setLicenseImages([])
                    setLicensePrevImage([])
                    setSelecteLicenseImages([])
                    setVideoLinks([])
                    setOnlineChecked(false)
                    setCommonLocationChecked(false)
                    setHomeVisitChecked(false)
                    navigate("/admin/provider/list")
                }
                setLoader(false);
            } catch (error) {
                toast.error(error.response.data.message, { autoClose: 3000 });
                setLoader(false);
            }

        }
  
    };

    const handleChange = (e) => {
        console.log(e.target.value, 'e.target.value');
      setCategoryId(e.target.value)
      }

    const handleSubcategoryChange = (e) => {
        console.log(e.target.value, 'e.target.value');
        setSubcategoryId(e.target.value)
      }

    const handleRemoveImage = (thumbnailKey, context) => {
        let prevImages, images, setPrevImages, setImages;
    
        if (context === 'portfolio') {
            prevImages = portfolioPrevImages;
            images = portfolioImages;
            setPrevImages = setPortfolioPrevImages;
            setImages = setPortfolioImages;
        } else if (context === 'license') {
            prevImages = licensePrevImage;
            images = licenseImages;
            setPrevImages = setLicensePrevImage;
            setImages = setLicenseImages;
        }
    
        const index = prevImages.findIndex(image => image.key === thumbnailKey);
    
        if (index !== -1) {
            const fullSizeImageKey = images[index].key;
            setRemovedImages(prevRemovedImages => [...prevRemovedImages, thumbnailKey, fullSizeImageKey]);
    
            const updatedPrevImages = prevImages.filter((_, i) => i !== index);
            const updatedImages = images.filter((_, i) => i !== index);
    
            setPrevImages(updatedPrevImages);
            setImages(updatedImages);
        } else {
            console.error('Thumbnail image not found for key:', thumbnailKey);
        }
    };
    
      const removeImage = (index, context) => {
        if (context === 'portfolio') {
            const newImages = selectedPortfolioImages.filter((_, i) => i !== index);
            setSelectePortfolioImages(newImages);
            if (newImages.length === 0) {
                setFileInputKey(Date.now());
            }
        } else if (context === 'license') {
            const newImages = selectedLicenseImages.filter((_, i) => i !== index);
            setSelecteLicenseImages(newImages);
            if (newImages.length === 0) {
                setFileInputKey(Date.now());
            }
        }
    };

     const handleRemoveVideoLink = (index) => {
        const newVideoLinks = videoLinks.filter((_, i) => i !== index);
        setVideoLinks(newVideoLinks);
      };
    
      const handleAddVideoLink = () => {
        setVideoLinks([...videoLinks, '']);
      };
    
      const handleVideoLinkChange = (index, value) => {
        const newVideoLinks = videoLinks.map((link, i) => (i === index ? value : link));
        setVideoLinks(newVideoLinks);
      };

    return (
        <>
            <div className="content">
                <Button
                    color="primary"
                    className="ml-10 common-button"
                    onClick={() => navigate("/admin/provider/list")}
                >
                    <IoMdArrowRoundBack /> Back
                </Button>
                <Container>
                    {loader && (
                        <span className="table-loader">
                            <Spinner color="primary">Loading...</Spinner>
                        </span>
                    )}
                    {!loader && (
                        <Form onSubmit={handleSubmit}>
                            <Card>
                                <CardBody className="mb-15">
                                    <div>
                                        <Row>
                                            <Col md="10">
                                                <div className="card-heading">
                                                    <Label>Service Details</Label>
                                                </div>
                                            </Col>
                                           
                                        </Row>
                                    </div>
                                    <div>
                                        <Row>
                                            <Col md="12">
                                                <CardBody>
                                                    {/* Service Title */}
                                                    <Row className="mt-3">
                                                        <Col md="12">
                                                            <FormGroup>
                                                                <Label for="serviceTitle">Service Title</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="serviceTitle"
                                                                    id="serviceTitle"
                                                                    value={serviceTitle}
                                                                    onChange={(e) => setServiceTitle(e.target.value)}
                                                                />
                                                                    {errors.serviceTitle && (
                                                                    <div className="error-message">{errors.serviceTitle}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    {/* Service Category and Subcategory */}
                                                    <Row className="mt-3">
                                                        <Col md="6">
                                                            <FormGroup>
                                                                <Label for="serviceCategory">Service Category</Label>
                                                                <Input
                                                                    id="exampleSelect"
                                                                    name="select"
                                                                    onChange={handleChange}
                                                                    type="select"
                                                                    value={categoryId}
                                                                    >
                                                                    <option value="" disabled selected>
                                                                        Select a category
                                                                    </option>
                                                                    {categories.map((category) => {
                                                                        return (
                                                                        <option value={category.categoryId}>
                                                                            {category.categoryName}
                                                                        </option>
                                                                        );
                                                                    })}
                                                                    </Input>
                                                                    {errors.categoryId && (
                                                                    <div className="error-message">{errors.categoryId}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6">
                                                            <FormGroup>
                                                            <Label for="serviceCategory">Service Subcategory</Label>
                                                            <Input
                                                                    id="exampleSelect"
                                                                    name="select"
                                                                    onChange={handleSubcategoryChange}
                                                                    type="select"
                                                                    value={subcategoryId}
                                                                    >
                                                                    <option value="" disabled selected>
                                                                        Select a subcategory
                                                                    </option>
                                                                    {allSubCategories.map((subcategory) => {
                                                                        return (
                                                                        <option value={subcategory.subcategoryId}>
                                                                            {subcategory.subcategoryName}
                                                                        </option>
                                                                        );
                                                                    })}
                                                                    </Input>
                                                                    {errors.subcategoryId && (
                                    <div className="error-message">{errors.subcategoryId}</div>
                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    {/* Pricing Details */}
                                                    <Row className="mt-3">
                                                    <Col md="4">
                                                        <FormGroup className="d-flex align-items-center justify-content-between">
                                                            <Label for="commonLocationPrice" className="mr-2">Common Location Price</Label>
                                                            <div className="d-flex align-items-center">
                                                                <Input
                                                                    type="text"
                                                                    name="commonLocationPrice"
                                                                    id="commonLocationPrice"
                                                                    value={commonLocationPrice}
                                                                    onChange={(e) => setCommonLocationPrice(e.target.value)}
                                                                />
                                                                 {errors.commonLocationPrice && (
                                                                    <div className="error-message">{errors.commonLocationPrice}</div>
                                                                )}
                                                                </div>
                                                                <div>
                                                                <Input
                                                                    type="checkbox"
                                                                    name="commonLocationPriceCheckbox"
                                                                    id="commonLocationPriceCheckbox"
                                                                    className="ml-2 custom-checkbox"
                                                                    checked={commonLocationChecked}
                                                                    onChange={(e) => setCommonLocationChecked(e.target.checked)}
                                                                />

                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup className="d-flex align-items-center justify-content-between">
                                                            <Label for="homeVisitPrice" className="mr-2">Home Visit Price</Label>
                                                            <div className="d-flex align-items-center">
                                                                <Input
                                                                    type="text"
                                                                    name="homeVisitPrice"
                                                                    id="homeVisitPrice"
                                                                    value={homeVisitPrice}
                                                                    onChange={(e) => setHomeVisitPrice(e.target.value)}
                                                                />
                                                                    {errors.homeVisitPrice && (
                                                                    <div className="error-message">{errors.homeVisitPrice}</div>
                                                                )}
                                                            </div>
                                                            <div>
                                                                <Input
                                                                    type="checkbox"
                                                                    name="homeVisitPriceCheckbox"
                                                                    id="homeVisitPriceCheckbox"
                                                                    className="ml-2 custom-checkbox"
                                                                    checked={homeVisitChecked}
                                                                    onChange={(e) => setHomeVisitChecked(e.target.checked)}
                                                                />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="4">
                                                        <FormGroup className="d-flex align-items-center justify-content-between">
                                                            <Label for="onlinePrice" className="mr-2">Online Price</Label>
                                                            <div className="d-flex align-items-center">
                                                                <Input
                                                                    type="text"
                                                                    name="onlinePrice"
                                                                    id="onlinePrice"
                                                                    value={onlinePrice}
                                                                    onChange={(e) => setOnlinePrice(e.target.value)}
                                                                    
                                                                />
                                                                    {errors.onlinePrice && (
                                                                    <div className="error-message">{errors.onlinePrice}</div>
                                                                )}
                                                                </div>
                                                                <div>
                                                                <Input
                                                                    type="checkbox"
                                                                    name="onlinePriceCheckbox"
                                                                    id="onlinePriceCheckbox"
                                                                    className="ml-2 custom-checkbox"
                                                                    checked={onlineChecked}
                                                                    onChange={(e) => setOnlineChecked(e.target.checked)}
                                                                />
                                                                </div>
                                                        
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="extraChargesPrice">Extra Charges Price</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="extraChargesPrice"
                                                                    id="extraChargesPrice"
                                                                    value={extraChargesPrice}
                                                                    onChange={(e) => setExtraChargesPrice(e.target.value)}
                                                                />
                                                                 {errors.extraChargesPrice && (
                                                                    <div className="error-message">{errors.extraChargesPrice}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="maxPeopleAllowed">Max People Allowed</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="maxPeopleAllowed"
                                                                    id="maxPeopleAllowed"
                                                                    value={maxPeopleAllowed}
                                                                    onChange={(e) => setMaxPeopleAllowed(e.target.value)}
                                                                />
                                                                  {errors.maxPeopleAllowed && (
                                                                    <div className="error-message">{errors.maxPeopleAllowed}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="numberOfPeopleIncluded">Number Of People Included</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="numberOfPeopleIncluded"
                                                                    id="numberOfPeopleIncluded"
                                                                    value={numberOfPeopleIncluded}
                                                                    onChange={(e) => setNumberOfPeopleIncluded(e.target.value)}
                                                                />
                                                                  {errors.numberOfPeopleIncluded && (
                                                                    <div className="error-message">{errors.numberOfPeopleIncluded}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    {/* Experience, Qualification, and Specialties */}
                                                    <Row className="mt-3">
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="specialities">Specialties</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="specialities"
                                                                    id="specialities"
                                                                    value={specialities}
                                                                    onChange={(e) => setSpecialities(e.target.value)}
                                                                />
                                                                 {errors.specialities && (
                                                                    <div className="error-message">{errors.specialities}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="qualification">Qualifications</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="qualification"
                                                                    id="qualification"
                                                                    value={qualification}
                                                                    onChange={(e) => setQualification(e.target.value)}
                                                                />
                                                            </FormGroup>
                                                            {errors.qualification && (
                                                                    <div className="error-message">{errors.qualification}</div>
                                                                )}
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <Label for="experience">Experience</Label>
                                                                <Input
                                                                    type="text"
                                                                    name="experience"
                                                                    id="experience"
                                                                    value={experience}
                                                                    onChange={(e) => setExperience(e.target.value)}
                                                                />
                                                                  {errors.experience && (
                                                                    <div className="error-message">{errors.experience}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    {/* Service Description */}
                                                    <Row className="mt-3">
                                                        <Col md="12">
                                                            <FormGroup>
                                                                <Label for="description">Service Description</Label>
                                                                <Input
                                                                    type="textarea"
                                                                    name="description"
                                                                    id="description"
                                                                    value={description}
                                                                    onChange={(e) => setDescription(e.target.value)}
                                                                />
                                                                   {errors.description && (
                                                                    <div className="error-message">{errors.description}</div>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3">
                                                        <Col md="6">
                                                        <Label for="videoLink" className="card-heading">Video Link:</Label>
                                                    {videoLinks.map((link, index) => (
                                                    <Row key={index} className="mb-2 align-items-center">
                                                        <Col md={10}>
                                                        <Input
                                                            type="text"
                                                            value={link}
                                                            onChange={(e) => handleVideoLinkChange(index, e.target.value)}
                                                        />       
                                                        </Col>
                                                        <Col md={2} className="text-right">
                                                        <Button color="link" onClick={() => handleRemoveVideoLink(index)}>
                                                            <RiDeleteBinLine size={24} />
                                                        </Button>
                                                        </Col>
                                                    </Row>
                                                    ))}
                                                    <Button color="link" onClick={handleAddVideoLink}>
                                                    <RiAddCircleLine size={24} />
                                                    </Button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Col>
                                        </Row>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                            <Col md="12">
                            <div className="card-heading">
                            <Label>Portfolio Images</Label>
                            </div>
                                <Input
                                type="file"
                                id="articleImage"
                                className="mb-4"
                                key={fileInputKey} // Add the key prop to force re-render
                                name="portfolioImage"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => handleImageSelection(e, 'portfolio')}  
                                multiple
                                />
                                {errors.portfolioImages && (
                                <div className="error-message mb-2">
                                    {errors.portfolioImages}
                                </div>
                                )}
                                <div className="d-flex flex-wrap">
                                {portfolioPrevImages && portfolioPrevImages.map((image, index) => (
                                    <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                                    <CardImg
                                        alt="Thumbnail"
                                        className="img-preview-small"
                                        src={image?.url}
                                        top
                                    />
                                    <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => handleRemoveImage(image.key, 'portfolio')}>
                                    <RiDeleteBinLine size={24} />
                                </Button>
                                    </div>
                                ))}
                                    {selectedPortfolioImages.map((image, index) => (
                                    <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                                        <CardImg
                                        src={URL.createObjectURL(image)}
                                        className="img-preview-small"
                                        alt={`preview-${index}`}
                                        style={{ width: '100px' }}
                                        />
                                    <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => removeImage(index, 'portfolio')}>
                                    <RiDeleteBinLine size={24} />
                                </Button>
                                    </div>
                                    ))}
                                </div>
                            </Col>
                            </Card>
                            <Card>
                                <Col md="12">
                                    <div className="card-heading">
                                        <Label>License Document</Label>
                                    </div>
                                    <Input
                                        type="file"
                                        id="articleImage"
                                        className="mb-4"
                                        key={fileInputKey} // Add the key prop to force re-render
                                        name="licenseDocuments"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        onChange={(e) => handleImageSelection(e, 'license')}
                                        multiple
                                    />
                                    {errors.licenseImages && (
                                        <div className="error-message mb-2">
                                            {errors.licenseImages}
                                        </div>
                                    )}
                                    <div className="d-flex flex-wrap">
                                        {licensePrevImage && licensePrevImage.map((image, index) => {
                                            const baseUrl = image?.url.split('?')[0];
                                            const checkExtension = baseUrl.split('.').pop().toLowerCase();

                                            return (
                                                <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                                                    {checkExtension === 'pdf' ? (
                                                        <CardImg
                                                        alt="Thumbnail"
                                                        className="img-preview-small"
                                                        src={pdf}
                                                        top
                                                    />
                                                    ) : (
                                                        <CardImg
                                                            alt="Thumbnail"
                                                            className="img-preview-small"
                                                            src={image.url}
                                                            top
                                                        />
                                                    )}
                                                    <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => handleRemoveImage(image.key, 'license')}>
                                                        <RiDeleteBinLine size={24} />
                                                    </Button>
                                                </div>
                                            );
                                        })}
                                        {selectedLicenseImages.map((file, index) => (
                                            <div key={index} className="img-preview-container position-relative mr-2 mb-2">
                                                {file.type === 'application/pdf' ? (
                                                    // <div className="pdf-preview-small" style={{ width: '100px', height: '100px', overflow: 'hidden' }}>
                                                    //     <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                                                    //         <Viewer fileUrl={URL.createObjectURL(file)} />
                                                    //     </Worker>
                                                    // </div>
                                                    <CardImg
                                                    src={pdf}
                                                    className="img-preview-small"
                                                    alt={`preview-${index}`}
                                                    style={{ width: '100px' }}
                                                />
                                                ) : (
                                                    <CardImg
                                                        src={URL.createObjectURL(file)}
                                                        className="img-preview-small"
                                                        alt={`preview-${index}`}
                                                        style={{ width: '100px' }}
                                                    />
                                                )}
                                                <Button color="link" size="sm" className="position-absolute" style={{ top: 0, right: 0 }} onClick={() => removeImage(index, 'license')}>
                                                    <RiDeleteBinLine size={24} />
                                                </Button>
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Card>
                            <Button type="submit" color="primary" className="ml-10 mt-4 common-button" >Update Service Details</Button>
                        </Form>
                    )}
                </Container>
            </div>
        </>
    );
}

export default UpdateProviderServiceDetails;
